<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useAbility } from "@casl/vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
import FinalDebondAddEdit from "@/components/models/patient/forms/visitInstructions/FinalDebondAddEdit.vue";
import { usePatient } from "@/composables/models/patient/usePatient.ts";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.finalDebondInstructions" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PATIENT__FINALDEBONDVISITINSTRUCTIONS);
    },
  },
});

const route = useRoute();
const routeParams = route.params as { id: string };
const { data: patient, isLoading: isPatientLoading } = usePatient({
  id: computed(() => routeParams.id),
});
</script>

<template>
  <v-skeleton-loader :loading="isPatientLoading">
    <final-debond-add-edit
      :patient="patient"
      creating
    />
  </v-skeleton-loader>
</template>

<style scoped></style>
